import { render, staticRenderFns } from "./Menu_1_1_2.vue?vue&type=template&id=05adaa2c&scoped=true"
import script from "./Menu_1_1_2.vue?vue&type=script&lang=js"
export * from "./Menu_1_1_2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05adaa2c",
  null
  
)

export default component.exports